import type { ComponentType, ReactNode, SVGProps } from 'react';
import { DocumentChartBarIcon } from '@heroicons/react/24/outline';

/**
 * Empty-state card used inside library list pages when there's nothing to
 * show — either because the user hasn't created anything yet or because the
 * active filters exclude every row. Each library list page supplies the
 * appropriate title/description/icon for its content.
 */
export function LibraryListEmptyState(props: {
  title: string;
  description?: ReactNode;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  /** Optional call-to-action (e.g. "Upload your first form" button). */
  action?: ReactNode;
  /** Drops the card chrome, for use inside a card that already has it. */
  embedded?: boolean;
}) {
  const Icon = props.icon ?? DocumentChartBarIcon;
  return (
    <div
      className={`px-4 py-12 text-center sm:px-6 ${
        props.embedded ? '' : 'rounded-lg bg-white shadow dark:bg-neutral-800'
      }`}
    >
      <Icon className="mx-auto h-12 w-12 text-neutral-400 dark:text-neutral-500" />
      <h3 className="mt-2 text-sm font-semibold text-neutral-900 dark:text-white">{props.title}</h3>
      {props.description && (
        <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">{props.description}</p>
      )}
      {props.action && <div className="mt-6">{props.action}</div>}
    </div>
  );
}
